import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Container from "./Container";
import Button from "./Button";
import MenuItem from "./MenuItem";
import { AuthContext } from "../AuthContext";
import { toast } from "react-hot-toast";

export default function MobileMenu({
  isOpen,
  onClose,
  navItems = [],
  authButtons = [],
  className = "",
}) {
  const { user, logoutUser } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleLogout = async () => {
    await logoutUser();
    toast.success("Déconnecté");
    onClose?.();
    navigate("/login");
  };

  return (
    <div className={`md:hidden border-t border-slate-100 ${className}`}>
      <Container className="py-2 space-y-1">
        {navItems.map((item) => (
          <MenuItem
            key={item.id}
            item={item}
            className="block px-2 py-2"
            onClick={onClose}
          />
        ))}
        <div className="flex flex-col gap-2 pt-2">
          {user ? (
            <>
              <Button
                as={Link}
                to="/profile"
                variant="secondary"
                onClick={onClose}
              >
                Voir le profil
              </Button>
              {/* <Button as={Link} to="/welcome" variant="ghost" onClick={onClose}>
                Voir les apps
              </Button>
              <Button as={Link} to="/" variant="ghost" onClick={onClose}>
                Revenir à la Landing Page
              </Button> */}
              <Button onClick={handleLogout} variant="ghost">
                Se déconnecter
              </Button>
            </>
          ) : (
            authButtons.map((button) => (
              <Button
                key={button.id}
                as={Link}
                to={button.to}
                variant={button.variant}
                onClick={onClose}
              >
                {button.label}
              </Button>
            ))
          )}
        </div>
      </Container>
    </div>
  );
}
